import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rms-permission-lock-popover',
    templateUrl: './permission-lock-popover.component.html',
    standalone: false
})
export class PermissionLockPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
